<template>
  <article>
    <h1>hm</h1>
    <section>
        Thats a <span class="red">four</span> oh <span class="red">four</span> :c
    </section>
  </article>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
